import { Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

/** Peças do menu do perfil.
 *
 * Os estilos ficam inline porque o antd aplica os proprios no `.ant-btn` e uma
 * classe nossa dependeria da ordem das folhas para vencer.
 */

const ESTILO_ICONE = { color: "white", paddingRight: 10 };
const ESTILO_ROTULO = { color: "white", fontWeight: "600" };

const estiloBotao = ({ aninhado, separador }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  padding: aninhado ? "20px 10px 20px 26px" : "20px 10px 20px 10px",
  borderTop: separador ? "1px solid #0d484a" : undefined,
});

export const ItemMenu = ({
  icone: Icone,
  rotulo,
  onClick,
  aninhado = false,
  separador = true,
  loading = false,
}) => (
  <Button
    type="text"
    className="botaoHeader"
    style={estiloBotao({ aninhado, separador })}
    icon={<Icone style={ESTILO_ICONE} />}
    loading={loading}
    onClick={onClick}
  >
    <text style={ESTILO_ROTULO}>{rotulo}</text>
  </Button>
);

export const GrupoMenu = ({ icone: Icone, rotulo, aberto, onToggle, children }) => (
  <>
    <Button
      type="text"
      className="botaoHeader"
      style={estiloBotao({ aninhado: false, separador: true })}
      icon={<Icone style={ESTILO_ICONE} />}
      onClick={(event) => {
        // Sem isso o clique sobe para o fundo do menu, que fecha tudo.
        event.stopPropagation();
        onToggle();
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <text style={ESTILO_ROTULO}>{rotulo}</text>

        {aberto ? (
          <UpOutlined style={{ color: "white", marginLeft: 10 }} />
        ) : (
          <DownOutlined style={{ color: "white", marginLeft: 10 }} />
        )}
      </div>
    </Button>

    {aberto && children}
  </>
);
